import { render, staticRenderFns } from "./bottomButtons.vue?vue&type=template&id=5be002b3&scoped=true&"
import script from "./bottomButtons.vue?vue&type=script&lang=js&"
export * from "./bottomButtons.vue?vue&type=script&lang=js&"
import style0 from "./bottomButtons.vue?vue&type=style&index=0&id=5be002b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be002b3",
  null
  
)

export default component.exports